var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-content"},[_c('v-progress-linear',{staticClass:"mt-16",attrs:{"indeterminate":"","color":"secondary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }